import React, {useState, useEffect} from 'react'
import PageHeader from '../component/pageheader'
import {LoadEffect } from '../component/loader'
import { useSelector } from 'react-redux'
import './startup.css'
 const Startup =(Props)=> {
	
	const [notice, setNotice] = useState({
        isLoading : false,
        isDataFetching: false
    });

    const [searchTerm, setSearchTerm] = useState('');
    const [activeCategory, setActiveCategory] = useState('all');
    
    const menu = useSelector(state => state.rootReducer.sidebar);
    const userRole = useSelector(state => state.rootReducer.roles);
    
    // Extract unique categories from menu items
    const categories = menu && menu.length > 0 
        ? ['all', ...new Set(menu
            .filter(item => userRole.includes(item.ID) && item.isActive === 'Yes')
            .map(item => item.category || 'uncategorized'))]
        : ['all'];

  


    // Filter modules based on search term and active category
    const filteredModules = menu && menu.length > 0
        ? menu.filter(item => {
            const matchesSearch = item.menuName.toLowerCase().includes(searchTerm.toLowerCase());
            const matchesCategory = activeCategory === 'all' || 
                (item.category || 'uncategorized') === activeCategory;
            return userRole.includes(item.ID) && item.isActive === 'Yes' && 
                   matchesSearch && matchesCategory;
        })
        : [];
        
    // Handle search input change
    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };
    
    // Handle category tab click
    const handleCategoryClick = (category) => {
        setActiveCategory(category);
    };
        
    return (
        <>
            {notice.isLoading && <LoadEffect />}
            <div className="main-body">
                <div className="page-wrapper">
                    <PageHeader title={' Modules'} />

                    {/* The Page Body start here */}
                    <div className="page-body">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="card">
                                    <div className="card-body modules-container ">
                                        {/* Search and filter section */}
                                        <div className="modules-header">
                                            <div className="modules-title">Available Modules</div>
                                            <div className="search-container">
                                                <i className="fa fa-search search-icon"></i>
                                                <input 
                                                    type="text" 
                                                    className="search-input" 
                                                    placeholder="Search modules..." 
                                                    value={searchTerm}
                                                    onChange={handleSearchChange}
                                                />
                                            </div>
                                        </div>
                                        
                                        
                                        {/* Module cards */}
                                        {filteredModules.length > 0 ? (
                                            <div className="module-grid">
                                                {filteredModules.map((data, index) => (
                                                    <div className="module-card" key={index}>
                                                        <div className="module-header">
                                                            <div className="module-icon">
                                                                <i className={data.menuIcon}></i>
                                                            </div>
                                                        </div>
                                                        <div className="module-body">
                                                            <div>
                                                                <h3 className="module-title">{data.menuName}</h3>
                                                                <p className="module-description">
                                                                    {data.description || `Access ${data.menuName} functionality and features`}
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="module-footer">
                                                            <a href={data.menuUrl} className="module-btn">
                                                                Open Module
                                                            </a>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        ) : (
                                            <div className="no-modules">
                                                <i className="fa fa-search"></i>
                                                <p>No modules found matching your search criteria</p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* The Page Body close here */}
                </div>
            </div>
        </>
    );
        
}

export default React.memo(Startup) 